import React, { useEffect, useState } from "react";

const defaultForm = {
  title: "",
  amount: "",
  type: "expense",
  category: "Food",
  date: new Date().toISOString().slice(0,10),
  note: ""
};

const AddTransactionModal = ({ isOpen, onClose, onSubmit, loading }) => {
  const [form, setForm] = useState(defaultForm);

  useEffect(() => {
    if (isOpen) setForm({ ...defaultForm, date: new Date().toISOString().slice(0,10) });
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.title || !form.amount) return;
    // map `note` to `description` so backend receives expected field name
    const payload = {
      title: form.title,
      type: form.type,
      category: form.category,
      amount: Number(form.amount),
      description: form.note,
      date: form.date,
    };
    console.debug("[AddTransactionModal] submit payload:", payload);
    onSubmit(payload);
  };

  return (
    <div className="modal-overlay" onMouseDown={onClose}>
      <div className="modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Add Transaction</h3>
          <button className="close" onClick={onClose}>✕</button>
        </div>
        <form className="modal-body" onSubmit={handleSubmit}>
          <input name="title" placeholder="Title (e.g., Groceries)" value={form.title} onChange={handleChange} />
          <div className="row">
            <input type="number" step="0.01" name="amount" placeholder="Amount" value={form.amount} onChange={handleChange} />
            <select name="type" value={form.type} onChange={handleChange}>
              <option value="expense">Expense</option>
              <option value="income">Income</option>
            </select>
          </div>
          <div className="row">
            <select name="category" value={form.category} onChange={handleChange}>
              <option>Food</option>
              <option>Transport</option>
              <option>Utilities</option>
              <option>Shopping</option>
              <option>Health</option>
              <option>Salary</option>
              <option>Side Hustle</option>
              <option>Other</option>
            </select>
            <input type="date" name="date" value={form.date} onChange={handleChange} />
          </div>
          <textarea name="note" rows="3" placeholder="Notes (optional)" value={form.note} onChange={handleChange} />
          <button className="btn primary" type="submit" disabled={loading}>
          {loading ? "Saving..." : "Save"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddTransactionModal;
